import axiosClient from './axiosClient';
import ApiReq_Login from '../types/ApiReq_Login';

export default async function loginService(bodyRequest: ApiReq_Login) {
  try {
    const response = await axiosClient.post('/auth/login', bodyRequest);

    if (response.status !== 200) {
      return null;
    }

    return response.data;
  } catch (error: any) {
    console.log(error);
    return null;
  }
}
